import { getAllCoursesStatic } from '../pages/cours/courses-data';

// Pages statiques de base
const staticPages = [
  {
    url: '/',
    priority: 1.0,
    changefreq: 'weekly'
  },
  {
    url: '/courses',
    priority: 0.9,
    changefreq: 'weekly'
  },
  {
    url: '/pass-codeur',
    priority: 0.8,
    changefreq: 'monthly'
  },
  {
    url: '/login',
    priority: 0.5,
    changefreq: 'yearly'
  },
  {
    url: '/register',
    priority: 0.5,
    changefreq: 'yearly'
  },
  {
    url: '/profile',
    priority: 0.4,
    changefreq: 'monthly'
  },
  {
    url: '/project',
    priority: 0.6,
    changefreq: 'weekly'
  },
  {
    url: '/play',
    priority: 0.7,
    changefreq: 'daily'
  }
];

// Générer les URLs des cours
export const generateCourseUrls = () => {
  const courses = getAllCoursesStatic();
  const courseUrls = [];

  courses.forEach(course => {
    // Page d'introduction du cours
    courseUrls.push({
      url: `/cours/${course.id}`,
      priority: course.isFree ? 0.9 : 0.8,
      changefreq: 'monthly',
      lastmod: new Date().toISOString().split('T')[0]
    });

    // Note: Les chapitres individuels ne sont pas inclus dans le sitemap
    // car ils nécessitent une authentification et ne sont pas indexables publiquement
  });

  return courseUrls;
};

// Générer le sitemap complet
export const generateSitemap = (baseUrl = 'https://monpremierjeu.fr') => {
  const currentDate = new Date().toISOString().split('T')[0];
  
  // Combiner toutes les URLs
  const allPages = [
    ...staticPages.map(page => ({
      ...page,
      lastmod: currentDate
    })),
    ...generateCourseUrls()
  ];

  // Générer le XML du sitemap
  const sitemapXml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"
        xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
        xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9
        http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
${allPages.map(page => `  <url>
    <loc>${baseUrl}${page.url}</loc>
    <lastmod>${page.lastmod}</lastmod>
    <changefreq>${page.changefreq}</changefreq>
    <priority>${page.priority}</priority>
  </url>`).join('\n')}
</urlset>`;

  return sitemapXml;
};

// Fonction pour télécharger le sitemap (côté client)
export const downloadSitemap = () => {
  const sitemapContent = generateSitemap();
  const blob = new Blob([sitemapContent], { type: 'application/xml' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = 'sitemap.xml';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
};

// Fonction pour afficher les statistiques du sitemap
export const getSitemapStats = () => {
  const courseUrls = generateCourseUrls();
  const totalPages = staticPages.length + courseUrls.length;
  
  return {
    totalPages,
    staticPages: staticPages.length,
    coursePages: courseUrls.length,
    freeCoursesCount: courseUrls.filter(course => course.priority === 0.9).length,
    paidCoursesCount: courseUrls.filter(course => course.priority === 0.8).length
  };
};
